
import { Component, Mixins, Watch, Emit, Prop } from "vue-property-decorator";
import { Department, DepartmentGroup } from "../../../../domain/department";
import { DesignatedDoctorInformation, User } from "../../../../domain/user";
import { ProjectTeam } from "../../../../domain/projectTeam";
import { DepartmentFeatureAccessibleMixin } from "../../../department/mixins";
import { ProfessionFeatureAccessibleMixin } from "../../../profession/mixins";
import { UserFilterParameter } from "../../filters";
import Enumerable from "linq";

@Component
export default class MultiOrderableUserListSelectorWithFilterMixin extends Mixins(DepartmentFeatureAccessibleMixin, ProfessionFeatureAccessibleMixin) {
  @Emit()
  departmentChanged(changed: Department): void {}

  get title(): string {
    return this.name + "選択";
  }

  data(): any {
    return {
      filter: new UserFilterParameter(),
      department: null,
      defaultMultiSelect: false,
      lastClickedUser: null,
      projectTeam: null,
      designatedDoctorInformations: null,
      name: "職員",
      defaultSelectedProfessionCodes: null as string[],
      isMultiSingleSwitchable: true,
      requiredUsers: null as User[],
      shouldHideSelectLoginUserButton: false,
      shouldHideClearSelectionButton: false,
    };
  }
  filter: UserFilterParameter;
  department: Department;
  defaultMultiSelect: boolean;
  lastClickedUser: User;
  projectTeam: ProjectTeam;
  designatedDoctorInformations: DesignatedDoctorInformation[];
  name: string;
  defaultSelectedProfessionCodes: string[];
  isMultiSingleSwitchable: boolean;
  requiredUsers: User[];
  shouldHideSelectLoginUserButton: boolean;
  shouldHideClearSelectionButton: boolean;

  @Prop()
  departmentGroup: DepartmentGroup;
  
  get appliedFilter(): (source: User) => boolean {
    return s => this.filter.filter(s);
  }

  get selectedUser(): User {
    return this.lastClickedUser;
  }

  get selectionMaxCount(): number {
    return this.$configuration.behavior.user.multiSelector.max;
  }

  get additionMaxCount(): number {
    return this.$configuration.behavior.user.multiSelector.addition.max;
  }

  get isClearable(): boolean {
    return !this.requiredUsers || this.requiredUsers.length < 1;
  }

  async validateRequired(selected: any): Promise<boolean> {
    if (!this.requiredUsers || this.requiredUsers.length < 1) { return true; }
    
    const selectedUsers = selected as User[];
    const removedRequiredUsers = Enumerable.from(this.requiredUsers).where(o => Enumerable.from(selectedUsers).all(s => o.id !== s.id)).toArray();
    if (removedRequiredUsers.length > 0) {
      this.$warn("職員選択", "文書記載済みのため職員(" + Enumerable.from(removedRequiredUsers).select(u => u.name).toArray().join(",") + ")を外すことができません。");
      return false;
    }

    if (this.requiredUsers.length === selectedUsers.length) {
      this.$warn("職員選択", "文書記載済みの職員のみに変更できません。");
      return false;
    }

    return true;
  }

  onUserSelectorClicked(clicked: User): void {
    this.lastClickedUser = clicked;
  }

  get shouldShowProjectTeamSelector(): boolean {
    return this.$configuration.behavior.user.finder.shouldShowProjectTeamSelector;
  }

  get shouldShowDesignatedDoctorSelector(): boolean {
    return this.$configuration.behavior.user.finder.shouldShowDesignatedDoctorSelector;
  }

  get shouldShowBelongedAllDepartmentsSelector(): boolean {
    return this.$configuration.behavior.user.finder.shouldShowBelongedAllDepartmentsSelector;
  }

  @Watch("department")
  onDepartmentChanged(newValue: Department): void {
    this.departmentChanged(newValue);
  }
}
